import {observer} from "mobx-react";
import InputSearchGeneric from "@dropDesk/presentation/components/inputs/input_search";
import ButtonFilters from "src/presentation/pages/ticket/ui/search/search_bar/button_filters";
import React from "react";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {SectorEntity} from "@dropDesk/domain/entities/sector/sector.entity";
import {
    TicketsDescriptionStaticEntity
} from "@dropDesk/domain/entities/ticket_description_static/ticket_description_static.entity";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";
import {PeriodEnum} from "@dropDesk/utils/helpers/common";
import {TicketConfig} from "@dropDesk/domain/entities/ticket/ticket_config";
import {
    ContentInputSearchAndFilter,
    ContentInputSearch,
    ContentInputPeriod
} from "@dropDesk/presentation/pages/ticket/ui/search/search_bar/styled";
import InputPeriodSearch from "@dropDesk/presentation/pages/ticket/ui/search/search_bar/inputs_period_search";

const FiltersNotFixed = observer(
    ({
         onSearch,
         filterStatus,
         filterPriority,
         setFilterStatus,
         setFilterPriority,
         loading,
         setListOnlySectorEmpty,
         listOnlySectorEmpty,
         setFilterAttendant,
         filterAttendant,
         setFilterUserClient,
         filterUserClient,
         setFilterSector,
         filterSector,
         filterDescriptionStatic,
         setFilterDescriptionStatic,
         filterClient,
         setFilterClient,
         period,
         labelPeriod,
         setFilterPeriod,
         visiblePopupButtonFilter,
         setVisiblePopupButtonFilter,
     }: {
        onSearch: (searchParam?: string) => void,
        setFilterStatus: (filter: TicketConfig | null, withList?: boolean) => void,
        setFilterPriority: (filter: TicketConfig | null, withList?: boolean) => void,
        setFilterAttendant: (filter: UserEntity | null, withList?: boolean) => void,
        setFilterUserClient: (filter: UserEntity | null, withList?: boolean) => void,
        setFilterSector: (filter: SectorEntity | null, withList?: boolean) => void,
        setFilterDescriptionStatic: (filter: TicketsDescriptionStaticEntity | null, withList?: boolean) => void,
        setFilterClient: (filter: ClientEntity | null, withList?: boolean) => void,
        setListOnlySectorEmpty: (value: boolean, withList?: boolean) => void,
        setFilterPeriod: (period: Array<Date> | null, label: PeriodEnum | null, withList?: boolean) => void
        filterStatus: TicketConfig | null,
        filterPriority: TicketConfig | null,
        loading: boolean
        listOnlySectorEmpty: boolean
        filterAttendant: UserEntity | null
        filterUserClient: UserEntity | null
        filterSector: SectorEntity | null
        filterDescriptionStatic: TicketsDescriptionStaticEntity | null
        filterClient: ClientEntity | null
        period: Array<Date> | null
        labelPeriod: PeriodEnum | null
        visiblePopupButtonFilter: boolean
        setVisiblePopupButtonFilter: React.Dispatch<React.SetStateAction<boolean>>
    }) => {

        return (
            <ContentInputSearchAndFilter>
                <ContentInputSearch className="input-search-journey">
                    <InputSearchGeneric
                        inputSearchPlaceholder="Pesquise por protocolo, telefone ou contato"
                        loading={loading}
                        onSearch={(value) => onSearch(value)}
                        className={'input-filter-ticket-number'}
                        size={'large'}
                    />
                </ContentInputSearch>
                <ContentInputPeriod className="input-filter-period-journey">
                    <InputPeriodSearch
                        period={period}
                        labelPeriod={labelPeriod}
                        setFilterPeriod={setFilterPeriod}
                        loading={loading}
                        size={40}
                        variant="ticketList"
                    />
                </ContentInputPeriod>
                <ButtonFilters
                    setFilterPriority={setFilterPriority}
                    setFilterStatus={setFilterStatus}
                    setFilterAttendant={setFilterAttendant}
                    filterPriority={filterPriority}
                    filterStatus={filterStatus}
                    loading={loading}
                    onSearch={onSearch}
                    filterAttendant={filterAttendant}
                    setFilterUserClient={setFilterUserClient}
                    filterUserClient={filterUserClient}
                    filterSector={filterSector}
                    setFilterSector={setFilterSector}
                    filterDescriptionStatic={filterDescriptionStatic}
                    setFilterDescriptionStatic={setFilterDescriptionStatic}
                    listOnlySectorEmpty={listOnlySectorEmpty}
                    setListOnlySectorEmpty={setListOnlySectorEmpty}
                    setFilterClient={setFilterClient}
                    filterClient={filterClient}
                    visiblePopupButtonFilter={visiblePopupButtonFilter}
                    setVisiblePopupButtonFilter={setVisiblePopupButtonFilter}
                />

            </ContentInputSearchAndFilter>
        )
    })
export default FiltersNotFixed;
